"use client";

import { useSearch } from "@/context/SearchContext";
import { useLocalizedData } from "@/context/LocaleContext";
import { I18nData } from "@/types/i18n";
import SearchInput from "./search-input";
import "./search.scss";
import React from "react";

interface Props {
  i18nData?: I18nData;
}

const Search = React.memo(function Search({ i18nData }: Props) {
  const { searchResult, currentSearchTerm } = useSearch();
  const localizedData = useLocalizedData(i18nData);

  return (
    <div className="topLeftWrapper">
      <header
        id="header"
        dangerouslySetInnerHTML={{ __html: localizedData?.search_title ?? "" }}
      ></header>
      <SearchInput
        searchHelper={localizedData?.search_helper ?? ""}
      />
      <p id="resultsCount">
        {searchResult
          ? searchResult.total_count > 0
            ? localizedData?.results_found
                ?.replace('{{count}}', searchResult.total_count.toString())
                ?.replace('{{term}}', `"${currentSearchTerm}"`)
            : localizedData?.no_results_found
                ?.replace('{{term}}', `"${currentSearchTerm}"`)
          : ""}
      </p>
    </div>
  );
});

export default Search;
